<template>
  <v-row>
    <v-col class="col-12">
      <v-checkbox
        :label="title"
        v-model="isSetActive"
        @change="setActiveChangeHandler"
      ></v-checkbox>
    </v-col>
    <v-col class="col-6" v-for="dto in dtoItems" :key="dto.product.id">
      <rent-set-orderr-item
        v-bind:rentSetItemDto="dto"
        v-bind:orderr-item-group="orderrItemGroup"
        @change="orderrItemChange"
      >
      </rent-set-orderr-item>
    </v-col>
  </v-row>
</template>

<script>
import RentSetOrderrItem from "@/components/RentSetOrderrItem";
import PriceCalculator from "@/libs/PriceCalculator";

export default {
  name: "RentSet",

  components: {
    RentSetOrderrItem,
  },

  data() {
    return {
      isSetActive: false,
      dtoItems: [],
    };
  },

  props: {
    set: {
      type: Object,
      required: true,
    },

    setIndex: {
      type: Number,
      required: true,
    },

    orderrItemGroup: {
      type: Object,
      required: true,
    },

    orderrItems: {
      type: Array,
      required: true,
    },
  },

  watch: {
    orderrItems: function (val) {
      console.log("OItems se zmenila");
      console.log(val);
      console.log("DTOcka:" + this.dtoItems.length);
      console.log("produkty:" + this.productsOfSet.length);
      console.log("OI:" + this.orderrItemsOfSet.length);

      // vzit produkty
      for (let i = 0; i < this.productsOfSet.length; i++) {
        let p = this.productsOfSet[i].product;
        console.log("produkt: ");
        console.log(p);
        let productFound = false;
        for (let j = 0; j < this.dtoItems.length; j++) {
          let dto = this.dtoItems[j];
          productFound = productFound || dto.product.id == p.id;
        }
        // kdyz produkt nema obraz v DTO, zalozit DTOcko
        if (!productFound) {
          let newDto = {
            product: p,
            orderrItem: null,
          };
          this.dtoItems.push(newDto);
        }
      }

      for (let k = 0; k < this.dtoItems.length; k++) {
        // reset OrderrItems v DTOckach
        this.dtoItems[k].orderrItem = null;
      }

      for (let l = 0; l < this.orderrItemsOfSet.length; l++) {
        let oi = this.orderrItemsOfSet[l];
        console.log("OI of set:");
        console.log(oi);
        // deaktivovat checkbox
        this.isSetActive = false;
        for (let k = 0; k < this.dtoItems.length; k++) {
          let dtocko = this.dtoItems[k];
          if (dtocko.product.id == oi.product.id) {
            dtocko.orderrItem = oi;

            // pripadne checkbox zas aktivovat
            this.isSetActive = true;
          }
        }
      }

      console.log("DTOcka - 2:" + this.dtoItems.length);
      console.log("produkty - 2:" + this.productsOfSet.length);
      console.log("OI - 2:" + this.orderrItemsOfSet.length);
      console.log(this.dtoItems);
    },
  },

  computed: {
    mobConfig() {
      return this.$store.state.mobConfig;
    },

    title() {
      let title = "Výhodný balíček: " + this.set.set.title;
      if (!this.isSetActive) {
        let priceDiff = 0;
        if (this.mobConfig.showPriceWithoutDPH) {
          priceDiff =
            this.setPrice.priceWithoutVat -
            this.orderrItemGroupPrice.priceWithoutVat;
        } else {
          priceDiff =
            this.setPrice.priceWithVat - this.orderrItemGroupPrice.priceWithVat;
        }

        title += " + ";
        title += priceDiff / 100 + " " + this.$t(this.mobConfig.currency);
      }
      return title;
    },

    productsOfSet: function () {
      let oigProductId = this.orderrItemGroup.product.id;

      return this.set.set.products.items.filter(function (item) {
        return item.product.id != oigProductId;
      });

      // vytvorit a udelat setItemDTO
      // product
      // orderrItem
    },

    orderrItemsOfSet: function () {
      return this.orderrItemGroup.orderrItems.filter(function (item, index) {
        return index > 0;
      });
    },

    orderrItemGroupPrice() {
      return PriceCalculator.calculatePriceOrderrItemGroup(
        this.orderrItemGroup,
        this.mobConfig.rentDiscountPercent
      );
    },

    setPrice() {
      return PriceCalculator.findPrice(
        this.set.set.priceTables,
        "DAILY",
        this.orderrItemGroup.length,
        this.orderrItemGroup.numberOfPersons,
        this.mobConfig.rentDiscountPercent
      );
    },
  },

  methods: {
    setActiveChangeHandler(isChecked) {
      let index = isChecked ? this.setIndex : 0;
      console.log("new index:" + index);
      console.log("setI:" + this.setIndex);
      this.$emit("setChange", index);
    },

    orderrItemChange(oi) {
      this.$emit("orderrItemChange", oi);
    },
  },
};
</script>

<style></style>
